import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ALK_EVENT_TYPE } from '../../model/enums';
import { AlkEvent } from '../../framework/events/alk.event';
import { WizEventManager } from '@wizeoo/akm-component-lib';

@Component({
  selector: 'user-edit-renderer',
  template: `<wiz-hgroup height="100%" width="100%" gap=5 horizontalAlign="center" verticalAlign="center" 
              (click)="$event.stopPropagation()" [wizDisabled]="params.wizDisabled">
              <wiz-icon [wizTooltip]="'$.user.edit.$'" tooltipPlacement="right"
              (click)="onEditClick()">edit</wiz-icon>
            </wiz-hgroup>
            `,
  styles: [':host {height:100%; width: 100%;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditUserNameRenderer implements AgRendererComponent {

  data: any;
  params: any;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) { }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.params = params;
    this.cdref.markForCheck();
  }

  onEditClick() {
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.EDIT, this.data));
  }
}
